/**
 * Reads a query string parameter without applying form-encoding rules.
 *
 * `URLSearchParams` (and therefore `useSearchParams`) treats the query string as
 * `application/x-www-form-urlencoded`, which turns every "+" into a space. Base64
 * values such as the ASP.NET Identity email confirmation token contain "+", so they
 * come back corrupted — and a consecutive "++" cannot be recovered afterwards.
 *
 * This reader only resolves percent-encoding, leaving "+" untouched, so both
 * percent-encoded links and legacy links carrying a raw token are read correctly.
 */
export const getRawQueryParam = (search, name) => {
    const query = (search || '').replace(/^\?/, '');
    if (!query) {
        return null;
    }

    const prefix = `${name}=`;
    const pair = query.split('&').find((part) => part.startsWith(prefix));
    if (pair === undefined) {
        return null;
    }

    const rawValue = pair.slice(prefix.length);
    try {
        return decodeURIComponent(rawValue);
    } catch (error) {
        // Malformed percent-encoding: the raw value is the best we have.
        return rawValue;
    }
};
